import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

export class CustomErrorMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective |
    NgForm | null): boolean {
        if(!control) {
            return false;
        }
        return !control.parent.valid;
   }
  }